import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './MainNavSection.scss'

import { NavLink } from 'react-router-dom'
import NotificationBubble from 'components/NotificationBubble'

const MainNavSection = ({
	align,
	path,
	icon,
	notifications,
	label,
	onClick
}) => {
	return (
		<div styleName={align === 'bottom' ? 'section-bottom' : 'section'}>
			{path
				? <NavLink
						to={path}
						className={styles.link}
						activeClassName={styles.active}
						exact={path === '/' ? true : false}
					>
						<div>
							<i className="material-icons" styleName="icon">
								{icon}
								<NotificationBubble amount={notifications} />
							</i>
						</div>
						<div styleName="label">
							{label}
						</div>
					</NavLink>
				: <div className={styles.link} onClick={onClick}>
						<div>
							<i className="material-icons" styleName="icon">
								{icon}
								<NotificationBubble amount={notifications} />
							</i>
						</div>
						<div styleName="label">
							{label}
						</div>
					</div>}
		</div>
	)
}
MainNavSection.propTypes = {
	path: React.PropTypes.string,
	icon: React.PropTypes.string,
	label: React.PropTypes.string,
	align: React.PropTypes.string,
	notifications: React.PropTypes.number
}

export default CSSModules(MainNavSection, styles)



// WEBPACK FOOTER //
// ./src/components/Navigation/MainNavSection.js